import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { useT } from '../i18n';

export default function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel,
  cancelLabel,
  onConfirm,
  variant = 'destructive',
  loading = false,
}) {
  const { t } = useT();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="confirm-dialog">
        <DialogHeader>
          <DialogTitle>{title || t('Confirm action')}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={loading}>
            {cancelLabel || t('Cancel')}
          </Button>
          <Button
            variant={variant}
            onClick={() => { onConfirm(); }}
            disabled={loading}
            data-testid="confirm-dialog-confirm"
          >
            {loading ? t('Please wait…') : (confirmLabel || t('Delete'))}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
